import TransformNode from './TypedNode'

import type { PluginVisitors, RehajePlugin } from '@rehaje/core'

export class TransformPlugin implements RehajePlugin {
  visitors: PluginVisitors = {
    nodes: {
      Transform: TransformNode
    }
  }
}
